
import { IconButton, Stack } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from 'ag-grid-react';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { AG_GRID_LOCALE_JP } from '../../themes/localeJP';
import LoadingOverlay, { DefaultLoadingMessage } from '../common/LoadingOverlay';
import NoRowsOverlay, { NoRowsMessage } from '../common/NoRowsOverlay';

import "../common/AgGridReactCustom.css"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { CONTENT_COLOR } from "../../models/Constants";
import { PageData } from "../../models/Index";
import PaginationCpn from "../common/PaginationCpn";
// -------------
// Props
export type UserGridProps = {
    pageSize?: number;
    pageData?: PageData;
    keyword: string;
    onSelected: (data: any) => void;
    onDoubleClick: (data: any) => void;
    onDeleteUser: (data: any) => void;
    onChangeSearchCondition: (name: string, value: any) => void;
    isSearch:boolean
};

// -------------
// Component
export const UserGrid = forwardRef((props: UserGridProps, ref) => {
    const {
        pageSize,
        pageData,
        keyword,
        onSelected,
        onDoubleClick,
        onDeleteUser,
        onChangeSearchCondition,
        isSearch
    } = props;
    const gridRef = useRef() as any;
    const [rowData, setRowData] = useState<any[]>([]);
    const [event, setEvent] = useState<any>();
    useImperativeHandle(ref, () => ({
        setRowData(value: any) {
            setRowData(value);
        },

        hideOverlay() {
            gridRef.current.api.hideOverlay();
        }
    }));
    useEffect(() =>{
        if(isSearch && event != undefined){
            event.node.setSelected(!event.node.isSelected());
        }
    },[isSearch])
    // Loading時のメッセージ
    const loadingOverlayComponent = useMemo(() => {
        return LoadingOverlay;
    }, []);
    
    const loadingOverlayComponentParams = useMemo(() => {
        return {
            loadingMessage: DefaultLoadingMessage,
        };
    }, []);

    const noRowsOverlayComponent = useMemo(() => {
        return NoRowsOverlay;
    }, []);

    const noRowsOverlayComponentParams = useMemo(() => {
        return {
            noRowsMessageFunc: () => NoRowsMessage,
        };
    }, []);

    // 全列に共通の定義
    const defaultColDef = {
        sortable: true, // ソート可
        editable: false, // 編集不可
        resizable: true,
        suppressMovable: true,  // 列の移動を無効にする
    };

    // 列タイプの定義
    const columnTypes = {
        nonEditableColumn: { editable: false }, // 編集不可
    };

    const handleChecked =(e:any) =>{
        onSelected(e.data)
        setEvent(e)
    }

    const handleRowDoubleClick = (e:any) => {
        onSelected(e.data)
        onDoubleClick(e.data)
    }

    const handleOpenDelete = (e:any) => {
        onSelected(e.data)
        onDeleteUser(e.data)
    }

    const CellControlRenderer = (props: any) => {
        return (
            <Stack direction={"row"} justifySelf={"center"} >
                    <IconButton onClick={()=>handleRowDoubleClick(props)}><EditIcon sx={{color:CONTENT_COLOR}}/></IconButton>
                    <IconButton onClick={()=>handleOpenDelete(props)}><DeleteIcon sx={{color:CONTENT_COLOR}}/></IconButton>
            </Stack>
        );
    };

    // 列の個別定義
    const columnDefs = [
        
        {
            headerName: "メールアドレス",
            field: "email",
            rowDrag: false,
            flex: 5,
        },
        {
            headerName: "氏名",
            field: "userName",
            rowDrag: false,
            flex: 4,
        },
        {
            headerName: "生年月日",
            field: "dateOfBirth",
            rowDrag: false,
            flex: 4,
        },
        {
            headerName: "",
            field: "",
            rowDrag: false,
            flex: 2,
            cellRenderer: CellControlRenderer,
        }
    ];
    const rowHeight = 48;
    gridRef.current?.api?.setQuickFilter(keyword);
    return (
        <>
            <div>
                <div className="ag-theme-alpine custom-grid" style={{ height: 'calc(100vh - 250px)', width: "100%"}}>
                    <AgGridReact
                        ref={gridRef}
                        defaultColDef={defaultColDef}
                        columnTypes={columnTypes}
                        columnDefs={columnDefs}
                        domLayout={"normal"}
                        rowData={rowData}
                        animateRows={true}
                        rowDragManaged={true}
                        suppressMovableColumns={false}
                        suppressDragLeaveHidesColumns={false}
                        rowHeight={rowHeight}
                        localeText={AG_GRID_LOCALE_JP}
                        loadingOverlayComponent={loadingOverlayComponent}
                        loadingOverlayComponentParams={loadingOverlayComponentParams}
                        noRowsOverlayComponent={noRowsOverlayComponent}
                        noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                        suppressRowHoverHighlight={true}
                        rowSelection={"single"}
                        onCellClicked={handleChecked}
                        onRowDoubleClicked={handleRowDoubleClick}
                    />
                </div>
                {pageSize && pageData && <PaginationCpn  pageData={pageData} onChangeSearchCondition={onChangeSearchCondition} limit={pageSize} />}
            </div>
        </>
    );
});

export default UserGrid;